import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ComparisonTable() {
  const titleRef = useScrollAnimation();

  const plans = [
    {
      name: 'Individual & Family',
      coverage: 'Comprehensive medical, dental, vision',
      deductible: '$1,000 - $8,000',
      premiumRange: '$300 - $800/month',
      bestFor: 'Self-employed, families, individuals',
      features: ['Preventive care', 'Prescription coverage', 'Emergency services', 'Specialist visits']
    },
    {
      name: 'Group/Employer',
      coverage: 'Full medical benefits package',
      deductible: '$500 - $3,000',
      premiumRange: '$200 - $600/month',
      bestFor: 'Small to large businesses',
      features: ['Lower premiums', 'Employer contribution', 'Multiple plan options', 'Wellness programs']
    },
    {
      name: 'Medicare Supplement',
      coverage: 'Fills Medicare gaps',
      deductible: '$0 - $2,000',
      premiumRange: '$100 - $400/month',
      bestFor: 'Seniors 65+, disabled individuals',
      features: ['No network restrictions', 'Predictable costs', 'Travel coverage', 'Guaranteed renewable']
    },
    {
      name: 'Short-Term Health',
      coverage: 'Temporary medical coverage',
      deductible: '$1,000 - $10,000',
      premiumRange: '$100 - $300/month',
      bestFor: 'Gap coverage, temporary needs',
      features: ['Quick approval', 'Flexible terms', 'Lower cost', 'Emergency protection']
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 
          ref={titleRef.ref}
          className={`text-4xl md:text-5xl font-serif font-bold text-center mb-4 text-primary transition-all duration-1000 ${
            titleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Compare Insurance Plans
        </h2>
        <p className="text-center text-lg text-gray-600 mb-12 max-w-3xl mx-auto">
          Choose the plan that fits your needs and budget
        </p>

        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow-lg">
            <thead>
              <tr className="bg-primary text-white">
                <th className="py-4 px-6 text-left text-sm font-semibold">Plan Type</th>
                <th className="py-4 px-6 text-left text-sm font-semibold">Coverage</th>
                <th className="py-4 px-6 text-left text-sm font-semibold">Deductible Range</th>
                <th className="py-4 px-6 text-left text-sm font-semibold">Premium Range</th>
                <th className="py-4 px-6 text-left text-sm font-semibold">Best For</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan, index) => (
                <tr key={index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                  <td className="py-4 px-6 font-semibold text-primary">{plan.name}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{plan.coverage}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{plan.deductible}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{plan.premiumRange}</td>
                  <td className="py-4 px-6 text-sm text-gray-700">{plan.bestFor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            *Rates vary based on age, location, and coverage level. Contact us for personalized quotes.
          </p>
        </div>
      </div>
    </section>
  );
}
